import Vue from 'vue'
import Router from 'vue-router'

import PureRouterViewComponent from '@/components/base/PureRouterView.vue'

import Layout from './components/base/Layout.vue'

Vue.use(Router)

export default new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes: [
        {
            path: '/',
            name: 'layout',
            component: Layout,
            redirect: '/account',
            children: [
                {
                    path: '/channel',
                    name: 'channel',
                    redirect: '/channel/bank',
                    component: PureRouterViewComponent,
                    meta: { title: 'nav.channel.title', icon: 'channel', code: 'channelConfigView' },
                    children: [
                        {
                            path: 'bank',
                            name: 'channel/bank',
                            meta: { title: 'nav.channel.bank.title', code: 'channelsAndBanksView', keepAlive: true },
                            component: () => import('./views/channel/bank/bank.vue')
                        },
                        {
                            path: 'merchant',
                            name: 'merchant',
                            meta: { title: 'nav.channel.merchant.title', code: 'tenantsAndChannelsView', keepAlive: true },
                            component: () => import('./views/channel/merchant/merchant.vue')
                        },
                        {
                            path: 'channel',
                            name: 'channel/channel',
                            meta: { title: 'nav.channel.channel.title', code: 'channelLlistView', keepAlive: true },
                            component: () => import('./views/channel/channel/channel.vue')
                        },
                        {
                            path: 'threepart',
                            name: 'threepart',
                            meta: { title: 'nav.channel.threepart.title', code: 'channelParametersView', keepAlive: true },
                            component: () => import('./views/channel/threepart/threepart.vue')
                        },
                        {
                            path: 'compare',
                            name: 'compare',
                            meta: { title: 'nav.channel.compare.title', code: 'tenantsAndBanksView', keepAlive: true },
                            component: () => import('./views/channel/compare/compare.vue')
                        }
                    ]
                },
                {
                    path: '/routing',
                    name: 'routing',
                    redirect: '/routing/lending',
                    component: PureRouterViewComponent,
                    meta: { title: 'nav.routing.title', icon: 'routing', code: 'routeConfigView' },
                    children: [
                        {
                            path: 'lending',
                            name: 'routing/lending',
                            meta: { title: 'nav.routing.lending.title', code: 'lendingRouteView', keepAlive: true },
                            component: () => import('./views/routing/lending/lending.vue')
                        },
                        {
                            path: 'repayment',
                            name: 'routing/repayment',
                            meta: { title: 'nav.routing.repayment.title', code: 'repaymentRouteView', keepAlive: true },
                            component: () => import('./views/routing/repayment/repayment.vue')
                        }
                    ]
                },
                {
                    path: '/bank',
                    name: 'bank',
                    redirect: '/bank/bankcard',
                    component: PureRouterViewComponent,
                    meta: { title: 'nav.bank.title', icon: 'bankcard', code: 'bankcardBindView' },
                    children: [
                        {
                            path: 'bankcard',
                            name: 'bankcard',
                            meta: { title: 'nav.bank.bankcard.title', code: 'userBankCardView', keepAlive: true },
                            component: () => import('./views/bankcard/bankcard.vue')
                        }
                    ]
                },
                {
                    path: '/receipt',
                    name: 'receipt',
                    redirect: '/receipt/lending',
                    component: PureRouterViewComponent,
                    meta: { title: 'nav.receipt.title', icon: 'receipt', code: 'receiptManageView' },
                    children: [
                        {
                            path: 'lending',
                            name: 'receipt/lending',
                            meta: { title: 'nav.receipt.lending.title', code: 'outcomeDocumentsView', hideChildren: true },
                            redirect: '/receipt/lending/list',
                            components: {
                                default: {
                                    render: h => h('router-view')
                                }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'receipt/lending/list',
                                    meta: { keepAlive: true },
                                    component: () => import('./views/receipt/lending/lending.vue')
                                },
                                {
                                    path: 'detail',
                                    name: 'receipt/lending/detail',
                                    meta: { title: 'nav.receipt.lending.detail.title' },
                                    component: () => import('./views/receipt/lending/detail.vue')
                                }
                            ]
                        },
                        {
                            path: 'repayment',
                            name: 'receipt/repayment',
                            meta: { title: 'nav.receipt.repayment.title', code: 'incomeDocumentsView', hideChildren: true },
                            redirect: '/receipt/repayment/list',
                            components: {
                                default: {
                                    render: h => h('router-view')
                                }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'receipt/repayment/list',
                                    meta: { keepAlive: true },
                                    component: () => import('./views/receipt/repayment/repayment.vue')
                                },
                                {
                                    path: 'detail',
                                    name: 'receipt/repayment/detail',
                                    meta: { title: 'nav.receipt.repayment.detail.title' },
                                    component: () => import('./views/receipt/repayment/detail.vue')
                                }
                            ]
                        },
                        {
                            path: 'documents',
                            name: 'receipt/documents',
                            redirect: '/receipt/documents/receiving',
                            components: {
                                default: {
                                    render: h => h('router-view')
                                }
                            },
                            meta: { title: 'nav.documents.title', code: 'bankcardBindView', hideChildren: true }, // TODO replace the icon and code
                            children: [
                                {
                                    path: 'receiving',
                                    name: 'receiving',
                                    meta: { keepAlive: true },
                                    component: () => import('./views/receipt/documents/receiving.vue')
                                }
                            ]
                        }
                    ]
                },
                {
                    path: '/account',
                    name: 'account',
                    redirect: '/account/company',
                    component: PureRouterViewComponent,
                    meta: { title: 'nav.account.title', icon: 'account', code: 'FC-ACCOUNTMANAGE' },
                    children: [
                        {
                            path: 'company',
                            name: 'company',
                            meta: { title: 'nav.account.company.subTitle', code: 'FC-ACCOUNTMANAGEMENU', keepAlive: true },
                            component: () => import('./views/account/company/company.vue')
                            // component: () => import('./views/subject/repayment/unpaid/unpaid-detail.vue')
                        },
                        {
                            path: 'personal',
                            name: 'personal',
                            meta: { title: 'nav.account.personal.subTitle', hidden: true },
                            component: () => import('./views/account/personal/personal.vue')
                        },
                        {
                            path: 'cash',
                            name: 'cash',
                            meta: { title: 'nav.subjectMatter.cashDetail', code: 'FC-CASHMENU', keepAlive: true },
                            component: () => import('./views/subject/cash/cash.vue')
                        },
                        {
                            path: 'blacklist',
                            name: 'blacklist',
                            meta: { title: 'nav.account.blacklist.subTitle', code: 'FC-BLACKLIST', keepAlive: true },
                            component: () => import('./views/account/blacklist/blacklist.vue')
                        },
                        {
                            path: 'third-customer',
                            name: 'third-customer',
                            meta: { title: 'thirdCustomer.title', code: 'thirdCustomerView', keepAlive: true },
                            component: () => import('./views/account/third-customer/third-customer.vue')
                        }
                    ]
                },
                {
                    path: '/credit',
                    name: 'credit',
                    redirect: '/credit/check',
                    meta: { title: 'nav.subjectMatter.credit', code: 'FC-CREDIT', icon: 'lend' },
                    component: PureRouterViewComponent,
                    children: [
                        {
                            path: 'receipt',
                            name: 'credit-receipt',
                            meta: { title: 'nav.subjectMatter.credit.receipt', hidden: true },
                            component: () => import('./views/subject/credit/receipt/receipt.vue')
                        },
                        {
                            path: 'check',
                            name: 'credit-check',
                            meta: { title: 'nav.subjectMatter.credit.check', code: 'FC-AUDITMENU', keepAlive: true },
                            component: () => import('./views/subject/credit/check/check.vue')
                        },
                        {
                            path: 'loan',
                            name: 'loan',
                            meta: { title: 'nav.subjectMatter.loan', code: 'FC-LOANMENU', hideChildren: true },
                            component: PureRouterViewComponent,
                            redirect: '/credit/loan/record',
                            children: [
                                {
                                    path: 'record',
                                    name: 'loan-record',
                                    meta: { title: '', keepAlive: true },
                                    component: () => import('./views/subject/loan/loan-record.vue')
                                },
                                {
                                    path: 'detail',
                                    name: 'loan-detail',
                                    meta: { title: 'nav.subjectMatter.loan.detail' },
                                    component: () => import('./views/subject/loan/loan-detail.vue')
                                },
                                {
                                    path: 'result',
                                    name: 'loan-result',
                                    meta: { title: 'routing.lendingDetail' },
                                    component: () => import('./views/receipt/lending/lending.vue')
                                },
                                {
                                    path: 'lending-detail',
                                    name: 'loan/lending/detail',
                                    meta: { title: 'nav.receipt.lending.detail.title' },
                                    component: () => import('./views/receipt/lending/detail.vue')
                                },
                                {
                                    path: 'unpaid-detail',
                                    name: 'loan/unpaid-detail',
                                    meta: { title: 'nav.subjectMatter.repayment.detail' },
                                    component: () => import('./views/subject/repayment/unpaid/unpaid-detail.vue')
                                }
                            ]
                        }
                    ]
                },
                {
                    path: '/repayment',
                    name: 'repayment',
                    meta: { title: 'nav.subjectMatter.repayment', code: 'FC-REPAYMENT', icon: 'repayment' },
                    redirect: '/repayment/unpaid',
                    component: PureRouterViewComponent,
                    children: [
                        {
                            path: 'unpaid',
                            name: 'unpaid',
                            meta: {
                                title: 'nav.subjectMatter.repayment.unpaid',
                                code: 'FC-REPAYMENTDETAILMENU',
                                hideChildren: true
                            },
                            component: PureRouterViewComponent,
                            redirect: '/repayment/unpaid/record',
                            children: [
                                {
                                    path: 'record',
                                    name: 'unpaid-record',
                                    meta: { title: '', keepAlive: true },
                                    component: () => import('./views/subject/repayment/unpaid/unpaid-record.vue')
                                },
                                {
                                    path: 'detail',
                                    name: 'unpaid-detail',
                                    meta: { title: 'nav.subjectMatter.repayment.detail' },
                                    component: () => import('./views/subject/repayment/unpaid/unpaid-detail.vue')
                                },
                                {
                                    path: 'result',
                                    name: 'unpaid-result',
                                    meta: { title: 'routing.repaymentDetail' },
                                    component: () => import('./views/receipt/repayment/repayment.vue')
                                },
                                {
                                    path: 'repayment-detail',
                                    name: 'unpaid/repayment-detail',
                                    meta: { title: 'nav.receipt.repayment.detail.title' },
                                    component: () => import('./views/receipt/repayment/detail.vue')
                                }
                            ]
                        },
                        {
                            path: 'penalty',
                            name: 'penalty',
                            component: PureRouterViewComponent,
                            redirect: '/repayment/penalty/record',
                            meta: { title: 'nav.subjectMatter.repayment.penalty', code: 'FC-PENALTYMENU', hideChildren: true },
                            children: [
                                {
                                    path: 'record',
                                    name: 'penalty-record',
                                    meta: { title: '', keepAlive: true },
                                    component: () => import('./views/subject/repayment/penalty/penalty-record.vue')
                                },
                                {
                                    path: 'detail',
                                    name: 'penalty-detail',
                                    meta: { title: 'nav.subjectMatter.repayment.detail' },
                                    component: () => import('./views/subject/repayment/penalty/penalty-detail.vue')
                                }
                            ]
                        },
                        {
                            path: 'tallyBillApprove',
                            name: 'tallyBillApprove',
                            component: PureRouterViewComponent,
                            redirect: '/repayment/tallyBillApprove/record',
                            meta: { title: 'nav.subjectMatter.repayment.hx', code: 'FC-REPAYMENT-HXGL-MENU', hideChildren: true },
                            children: [
                                {
                                    path: 'record',
                                    name: 'tallyBillApproveRecord',
                                    meta: { title: '', keepAlive: true },
                                    component: () => import('./views/subject/repayment/tallybill/tallybill-record.vue')
                                }
                            ]
                        },
                        {
                            path: 'paymentEqualize',
                            name: 'paymentEqualize',
                            component: PureRouterViewComponent,
                            redirect: '/repayment/paymentEqualize/record',
                            meta: { title: '还款支付补单', code: 'FC-REPAYMENT-ZFBD-MENU', hideChildren: true },
                            children: [
                                {
                                    path: 'record',
                                    name: 'paymentEqualizeRecord',
                                    meta: { title: '', keepAlive: true },
                                    component: () => import('./views/subject/repayment/paymentEqualize/paymentEqualize-record.vue')
                                }
                            ]
                        }
                    ]
                },
                {
                    path: '/borrow',
                    meta: { title: 'nav.borrow.title', code: 'FC-REPAYMENT1', icon: 'borrow' }, // TODO need the new privillege code
                    redirect: '/personal',
                    component: PureRouterViewComponent,
                    children: [
                        {
                            path: 'personal',
                            name: 'borrow/personal',
                            meta: { title: 'nav.borrow.personal.title', code: 'FC-REPAYMENT', keepAlive: true },
                            component: () => import('./views/borrow/personal/index.vue')
                        },
                        {
                            path: 'company',
                            name: 'borrow/company',
                            meta: { title: 'nav.borrow.company.title', code: 'FC-REPAYMENT', keepAlive: true },
                            component: () => import('./views/borrow/company/index.vue')
                        }
                    ]
                },
                {
                    path: '/report',
                    name: 'report',
                    redirect: '/report/release',
                    component: PureRouterViewComponent,
                    meta: { title: 'nav.report.title', icon: 'subject', code: 'reportBindView' },
                    children: [
                        {
                            path: 'release',
                            name: 'release',
                            meta: { title: 'nav.report.title.loan', code: 'reportBindLoanView', keepAlive: true },
                            component: () => import('./views/report/release.vue')
                        },
                        {
                            path: 'repayment',
                            name: 'repayment',
                            meta: { title: 'nav.report.title.repayment', code: 'reportBindRepaymentView',keepAlive: true},
                            component: () => import('./views/report/repayment.vue')
                        },
                        {
                            path: 'daily',
                            name: 'daily',
                            meta: { title: 'nav.report.title.daily', code: 'reportBindDailyBusinessView',keepAlive: true},
                            component: () => import('./views/report/dailyBusiness.vue')
                        },
                    ]
                },
            ]
        },
        {
            path: '*',
            name: 'notFound',
            component: () => import('./components/common/NotFound.vue')
        }
    ]
})
